import { Button, Card, Form, Input, message, Select } from 'antd'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import styles from './PesertaForm.module.css'

// REDUX
import { useDispatch, useSelector } from 'react-redux'
import { selectCurrentUser } from '../../../../redux/user/user.selectors'
import { removeCurrentUser } from '../../../../redux/user/user.action'

import { useNavigate } from 'react-router-dom'
import { FetchLoading } from '../../../../components'
import { Option } from 'antd/lib/mentions'

message.config({
  maxCount: 1,
})

/* eslint-disable no-template-curly-in-string */
const validateMessages = {
  required: '${label} harus diisi!',
}
/* eslint-enable no-template-curly-in-string */

const PesertaForm = ({ title = '' }) => {
  const [loading, setLoading] = useState(true)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [statusData, setStatusData] = useState(null)
  const dispatch = useDispatch()

  const navigate = useNavigate()
  const currentUser = useSelector(selectCurrentUser)
  const [form] = Form.useForm()

  useEffect(() => {
    axios({
      method: 'get',
      url: '/peserta/create',
      headers: {
        Authorization: `Bearer ${currentUser.token}`,
      },
    })
      .then((response) => {
        setStatusData(response.data.status)
        setLoading(false)
      })
      .catch((error) => {
        if (error.response.status === 404) {
          message.error('404 Not Found')
        }
        if (error.response.status === 401) {
          message.error('401 Unauthorized')
          dispatch(removeCurrentUser())
          navigate('/login')
        }
        if (error.response.status === 500) {
          message.error('500 Internal Server Error')
        }
        if (error.response.status === 403) {
          message.error('403 Forbidden')
        }
      })
  }, [currentUser.token, dispatch, navigate])

  const onFinish = (values) => {
    setSubmitLoading(true)
    const {
      name,
      username,
      email,
      city,
      address,
      zip_code,
      phone,
      status,
      university,
      class_year,
      major,
      company,
      position,
      password,
      password_confirmation,
    } = values

    const data = JSON.stringify({
      name,
      username,
      email,
      city,
      address,
      zip_code,
      phone,
      status,
      university,
      class_year,
      major,
      company,
      position,
      password,
      password_confirmation,
    })

    axios({
      method: 'post',
      url: '/peserta',
      headers: {
        Authorization: `Bearer ${currentUser.token}`,
        'Content-Type': 'application/json',
      },
      data: data,
    })
      .then((response) => {
        if (response.data.status === false) {
          message.error('Gagal Tambah Peserta, Periksa Kembali')
          setSubmitLoading(false)
        } else {
          form.resetFields()
          message.success('Peserta Berhasil Ditambah')
          navigate('/peserta')
        }
      })
      .catch((error) => {
        if (error.response.status === 404) {
          message.error('404 Not Found')
        }
        if (error.response.status === 401) {
          message.error('401 Unauthorized')
          dispatch(removeCurrentUser())
          navigate('/login')
        }
        if (error.response.status === 500) {
          message.error('500 Internal Server Error')
        }
        if (error.response.status === 403) {
          message.error('403 Forbidden')
        }
      })
  }

  return (
    <FetchLoading data={statusData}>
      <div className={styles.container}>
        <div className={styles.card}>
          <h1 className={styles.title}>{title}</h1>
          {!loading && (
            <Form
              form={form}
              layout={'vertical'}
              onFinish={onFinish}
              validateMessages={validateMessages}>
              <Form.Item
                label="Nama"
                name="name"
                rules={[
                  {
                    required: true,
                  },
                ]}>
                <Input placeholder="Nama" size="large" />
              </Form.Item>
              <Form.Item
                label="Username"
                name="username"
                rules={[
                  {
                    required: true,
                  },
                ]}>
                <Input placeholder="Username" size="large" />
              </Form.Item>
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  {
                    type: 'email',
                    message: 'Email Tidak Valid',
                  },
                  {
                    required: true,
                  },
                ]}>
                <Input placeholder="Email" size="large" />
              </Form.Item>
              <Form.Item
                label="Kota"
                name="city"
                rules={[
                  {
                    required: true,
                  },
                ]}>
                <Input placeholder="Kota" size="large" />
              </Form.Item>
              <Form.Item
                label="Alamat"
                name="address"
                rules={[
                  {
                    required: true,
                  },
                ]}>
                <Input placeholder="Alamat" size="large" />
              </Form.Item>
              <Form.Item
                label="Kode Pos"
                name="zip_code"
                rules={[
                  {
                    required: true,
                  },
                ]}>
                <Input placeholder="Kode Pos" size="large" />
              </Form.Item>
              <Form.Item
                label="Nomor Telepon"
                name="phone"
                rules={[
                  {
                    required: true,
                  },
                ]}>
                <Input placeholder="Nomor Telepon" size="large" />
              </Form.Item>
              <Form.Item
                label="Status"
                name="status"
                rules={[{ required: true }]}>
                <Select placeholder="Pilih Status Peserta" size="large">
                  {statusData.map((item) => (
                    <Option value={item.id_status} key={item.id_status}>
                      {item.nama}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                noStyle
                shouldUpdate={(prevValues, currentValues) =>
                  prevValues.status !== currentValues.status
                }>
                {({ getFieldValue }) =>
                  getFieldValue('status') === 'mahasiswa' ||
                  getFieldValue('status') === 'freshgraduate' ? (
                    <Card style={{ marginBottom: 20 }}>
                      <Form.Item
                        label="Universitas"
                        name="university"
                        rules={[{ required: true }]}>
                        <Input placeholder="Universitas" size="large" />
                      </Form.Item>
                      <Form.Item
                        label="Tahun Masuk"
                        name="class_year"
                        rules={[{ required: true }]}>
                        <Input placeholder="Tahun Masuk" size="large" />
                      </Form.Item>
                      <Form.Item
                        label="Jurusan"
                        name="major"
                        rules={[{ required: true }]}>
                        <Input placeholder="Jurusan" size="large" />
                      </Form.Item>
                    </Card>
                  ) : null
                }
              </Form.Item>
              <Form.Item
                noStyle
                shouldUpdate={(prevValues, currentValues) =>
                  prevValues.status !== currentValues.status
                }>
                {({ getFieldValue }) =>
                  getFieldValue('status') === 'bekerja' ? (
                    <Card style={{ marginBottom: 20 }}>
                      <Form.Item
                        label="Perusahaan"
                        name="company"
                        rules={[{ required: true }]}>
                        <Input placeholder="Perusahaan" size="large" />
                      </Form.Item>
                      <Form.Item
                        label="Posisi"
                        name="position"
                        rules={[{ required: true }]}>
                        <Input placeholder="Tahun Masuk" size="large" />
                      </Form.Item>
                    </Card>
                  ) : null
                }
              </Form.Item>
              <Form.Item
                label="Password"
                name="password"
                hasFeedback
                rules={[
                  {
                    required: true,
                    min: 8,
                    message: 'Minimal 8 Karakter',
                  },
                ]}>
                <Input.Password placeholder="Password" size="large" />
              </Form.Item>
              <Form.Item
                label="Konfirmasi Password"
                name="password_confirmation"
                dependencies={['password']}
                hasFeedback
                rules={[
                  {
                    required: true,
                    min: 8,
                    message: 'Minimal 8 Karakter',
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve()
                      }

                      return Promise.reject(
                        new Error('Password yang anda masukkan tidak sesuai')
                      )
                    },
                  }),
                ]}>
                <Input.Password
                  placeholder="Konfirmasi Password"
                  size="large"
                />
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={submitLoading}>
                  Submit
                </Button>
              </Form.Item>
            </Form>
          )}
        </div>
      </div>
    </FetchLoading>
  )
}

export default PesertaForm
